<div class="modal-content">

    <div mat-dialog-title class="d-flex justify-content-between flex-row modal-header align-items-center">

        <h3 class="d-flex flex-column justify-content-center">
            @if (mission) {
            {{mission.label}}
            } @else {
            <span class="text-it">Nouvelle mission</span>
            }
        </h3>

    </div>

    <mat-dialog-content class="modal-body">
        <mat-tab-group [disableRipple]="false">

            <mat-tab label="Informations générales">
                <ng-template matTabContent>

                    <form (submit)="submit()" [formGroup]="missionForm">
                        <div class="input-group mb-3 runner-data aoe-pmd-r-2 ">
                            <span class="input-group-text" id="basic-addon1">Nom <ng-container
                                    *ngTemplateOutlet="requiredTemplate; context:{controlName: 'label'}"></ng-container></span>
                            <input type="text" class="form-control" aria-label="volunteer-info"
                                aria-describedby="volunteer-info" formControlName="label"
                                [ngClass]="{'is-valid': isInputValid(missionForm.controls['label']) && missionForm.controls['label'].pristine, 'is-invalid': displayError(missionForm.controls['label'])}">
                        </div>

                        <div class="d-flex flex-column mb-3">
                            <div class="input-group ">
                                <span class="input-group-text" id="event-website">Description<ng-container
                                        *ngTemplateOutlet="requiredTemplate; context:{controlName: 'description'}"></ng-container></span>
                                <textarea name="Description" id="event-description" class="form-control" rows="3"
                                    [ngClass]="{'is-valid': isInputValid(missionForm.controls['description']), 'is-invalid': displayError(missionForm.controls['description'])}"
                                    formControlName="description"></textarea>
                            </div>
                            <span class="small">Décrivez la mission. Elle aidera vos bénévoles à se projeter sur les
                                tâches à effectuer sur cette mission </span>
                        </div>

                        <!-- <div class="d-flex flex-column mb-3">
                            <div class="input-group ">
                                <span class="input-group-text">Type de mission<ng-container
                                        *ngTemplateOutlet="requiredTemplate; context:{controlName: 'description'}"></ng-container></span>
                                <select class="form-select" aria-label="Default select example">
                                    <option *ngFor="let type of missionType">{{missionTypeLabel(type)}}</option>
                                </select>
                            </div>
                        </div> -->



                    </form>
                </ng-template>
            </mat-tab>
            <mat-tab label="Dates et créneaux de la mission">
                <ng-template matTabContent>
                    <!-- <div class="input-container input-date-time d-flex flex-column mb-3">
                        <div class="input-group">
                            <span class="input-group-text">Date et heure de début<ng-container
                                    *ngTemplateOutlet="requiredTemplate; context:{control: missionForm.controls['startDate']}"></ng-container></span>
                            <input type="datetime-local" id="startDate" name="startDate"
                                [ngClass]="{'is-valid': isInputValid(missionForm.controls['startDate']), 'is-invalid': displayError(missionForm.controls['startDate'])}"
                                formControlName="startDate" [max]="" class="form-control" step="1">
                        </div>
                    </div>

                    <div class="input-container input-date-time d-flex flex-column mb-3">
                        <div class="input-group">
                            <span class="input-group-text">Date et heure de fin<ng-container
                                    *ngTemplateOutlet="requiredTemplate; context:{control: missionForm.controls['endDate']}"></ng-container></span>
                            <input type="datetime-local" id="startDate" name="endDate"
                                [ngClass]="{'is-valid': isInputValid(missionForm.controls['endDate']), 'is-invalid': displayError(missionForm.controls['endDate'])}"
                                formControlName="endDate" [max]="" class="form-control" step="1">
                        </div>
                    </div> -->
                </ng-template>
            </mat-tab>



        </mat-tab-group>
    </mat-dialog-content>

</div>

<ng-template #requiredTemplate let-controlName="controlName">
    @if (isControlRequired(missionForm.controls[controlName])) {<span class="required"></span>}
</ng-template>